export default __webpack_public_path__ + "static/do-a452cfd3a6900a0a423777bb5f17f179.svg";